import React, { useState } from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./Map.css"; // Add this line
import L from "leaflet";
import axios from "axios";

// Fix marker icon issue with react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export const getAllPlaces = async () => {
  const API_URL = "http://localhost:3001";
  const response = await axios.get(`${API_URL}/api/placeWithimage`);
  return response.data;
};

const MapPage = () => {
  const [places, setPlaces] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [search, setSearch] = useState(""); // Add search state

  React.useEffect(() => {
    getAllPlaces()
      .then((data) => setPlaces(data))
      .catch((err) => console.error("Failed to fetch places:", err));
  }, []);

  // Helper to get lat/lon from place.Location
  const getLatLon = (location) => {
    let lat = null,
      lon = null;
    if (location) {
      if (typeof location === "string") {
        const [latStr, lonStr] = location.split(",").map((s) => s.trim());
        lat = parseFloat(latStr);
        lon = parseFloat(lonStr);
      } else if (typeof location === "object" && location !== null) {
        if (
          Array.isArray(location.coordinates) &&
          location.coordinates.length === 2
        ) {
          lon = parseFloat(location.coordinates[0]);
          lat = parseFloat(location.coordinates[1]);
        } else if (
          typeof location.x === "number" &&
          typeof location.y === "number"
        ) {
          lon = location.x;
          lat = location.y;
        }
      }
    }
    return (
      (typeof lat === "number" &&
        typeof lon === "number" &&
        !isNaN(lat) &&
        !isNaN(lon)
        ? [lat, lon]
        : null)
    );
  };

  // Filtered places for search
  const filteredPlaces = places.filter((place) =>
    place.PlaceName?.toLowerCase().includes(search.toLowerCase())
  );

  // Directions handler
  const handleDirections = () => {
    if (!selectedPlace) return;
    const latlon = getLatLon(selectedPlace.Location);
    if (!latlon) return;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLon = position.coords.longitude;
          window.open(
            `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLon}&destination=${latlon[0]},${latlon[1]}`,
            "_blank"
          );
        },
        () => {
          // If user denies location, just show destination
          window.open(
            `https://www.google.com/maps/dir/?api=1&destination=${latlon[0]},${latlon[1]}`,
            "_blank"
          );
        }
      );
    } else {
      window.open(
        `https://www.google.com/maps/dir/?api=1&destination=${latlon[0]},${latlon[1]}`,
        "_blank"
      );
    }
  };

  return (
    <div
      className="map-page-bg"
      style={{ minHeight: "unset", paddingBottom: "0" }}
    >
      <div className="row justify-content-center">
        <div className="col-lg-7 mb-2">
          {/* Search box */}
          <div className="mb-3 d-flex justify-content-center">
            <input
              type="text"
              className="form-control"
              placeholder="Search for a place..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ maxWidth: 350 }}
              autoFocus // <-- Add this prop for focus on mount
            />
          </div>
          {/* Show message if no places match the search */}
          {filteredPlaces.length === 0 && (
            <div
              className="alert alert-warning text-center py-2"
              style={{ maxWidth: 350, margin: "0 auto" }}
            >
              No places found.
            </div>
          )}
          <div className="card shadow border-0 map-card">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">Explore Tourist Attractions</h4>
            </div>
            <div className="card-body p-0">
              <MapContainer
                center={[24.4539, 54.3773]}
                zoom={7}
                className="custom-map-container"
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution="© OpenStreetMap contributors"
                />
                {filteredPlaces.map((place) => {
                  const latlon = getLatLon(place.Location);
                  if (!latlon) return null;
                  return (
                    <Marker
                      key={place.PlaceID}
                      position={latlon}
                      eventHandlers={{
                        click: () => setSelectedPlace(place),
                      }}
                    />
                  );
                })}
              </MapContainer>
            </div>
          </div>
          <div className="mt-3 mb-2">
            <p
              className="text-secondary text-center"
              style={{ marginBottom: "0.5rem" }}
            >
              <i className="bi bi-info-circle"></i> Click on a marker to view
              details about the attraction.
            </p>
            {selectedPlace && (
              <div className="card shadow border-0 mx-auto map-detail-card">
                <div className="row g-0 align-items-center">
                  {selectedPlace.Image && (
                    <div className="col-md-6 d-flex align-items-center justify-content-center map-image-col">
                      <img
                        src={selectedPlace.Image}
                        alt={selectedPlace.PlaceName}
                        className="img-fluid rounded-start map-detail-img"
                      />
                    </div>
                  )}
                  <div className={selectedPlace.Image ? "col-md-6" : "col-12"}>
                    <div className="card-body">
                      <h5
                        className="card-title text-primary"
                        style={{ fontSize: "1.5rem" }}
                      >
                        {selectedPlace.PlaceName}
                      </h5>
                      <p className="card-text map-desc">
                        {selectedPlace.Description}
                      </p>
                      <button
                        className="btn btn-success mt-2"
                        onClick={handleDirections}
                      >
                        Get Directions
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-5 d-flex align-items-center justify-content-center">
          {!selectedPlace && (
            <div className="text-center text-muted">
              <i className="bi bi-geo-alt" style={{ fontSize: 48 }}></i>
              <h5 className="mt-3">Select a marker to see details here</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapPage;
